import { Page, PageEmptyState, PageErrorState } from 'seagull';
import PageLoadingState from "../../components/PageLoadingState";
import RestfulWrapper from "../../components/RestfulWrapper/RestfulWrapper";
import { useStoreActions } from "../../store/store-context";
import { ActivityLogBusinessItem } from "./ActivityLogBusinessItem";
import { jsx as _jsx } from "react/jsx-runtime";
const title = 'Activity logs';
function ActualActivityLogsPage(_ref) {
  let {
    data,
    loading
  } = _ref;
  const businessEntries = data.filter(entry => entry.isBusinessEntry());
  const hasData = businessEntries.length > 0;
  return /*#__PURE__*/_jsx(Page, {
    header: title,
    skin: "secondary",
    "data-testid": "activity-logs-page",
    loading: loading,
    children: hasData ? /*#__PURE__*/_jsx("div", {
      "data-testid": "activity-logs-content",
      children: businessEntries.map((entry, index) => /*#__PURE__*/_jsx(ActivityLogBusinessItem, {
        entry: entry,
        isFirst: index === 0,
        isLast: index === businessEntries.length - 1
      }, entry.id()))
    }) : /*#__PURE__*/_jsx(PageEmptyState, {
      "data-testid": "activity-logs-empty",
      illustration: null,
      title: "No activity logs yet",
      message: "Logs will appear here once there is activity in your business."
    })
  });
}
export default function ActivityLogsPage() {
  const {
    api
  } = useStoreActions();
  return /*#__PURE__*/_jsx(RestfulWrapper, {
    fetch: api.business.getActivityLogs,
    renderChild: _ref2 => {
      let {
        data,
        loading
      } = _ref2;
      return /*#__PURE__*/_jsx(ActualActivityLogsPage, {
        data: data,
        loading: loading
      });
    },
    renderLoader: () => /*#__PURE__*/_jsx(PageLoadingState, {
      header: title,
      loading: true
    }),
    renderError: _ref3 => {
      let {
        refresh
      } = _ref3;
      return /*#__PURE__*/_jsx(PageErrorState, {
        "data-testid": "activity-logs-error",
        title: title,
        onRefresh: refresh
      });
    }
  });
}